<template>
  <div class="download">
    <div class="item-container">
      <template v-if="!isInit">
        <loading :message="'読み込み中...'"></loading>
      </template>

      <p v-else-if="isInit && isError" class="aligncenter">ファイルの取得に失敗しました</p>
      <p v-else-if="isInit && !isError && isEmpty" class="aligncenter">ファイルは登録されていません</p>

      <template v-else-if="isInit && !isError">
        <download-files v-model="tenpufiles" name="downloadfile" :input-name="true" name-label="名称"
          :base-url="thumbBaseUrl" accept=".png,.jpg,.pdf,.xlsx,.docx" @download:modelValue="fileDownload"
          @open:modelValue="fileOpenNewTab" :disabled="disabled"/>
      </template>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useFileDownload } from "@/composable/common/file-download";
import { isEmpty } from "lodash";
import { TenpuFile } from "@/types/TenpuFile";

export default defineComponent({
  props: {
    tenpufiles: {
      type: Object as () => TenpuFile[] | null,
      require: true,
      default: null
    },
    disabled: {
      type: Object as () => boolean,
      default: false
    }
  },
  setup(props) {
    const { fileDownload, fileOpenNewTab, thumbBaseUrl } = useFileDownload()

    const isInit = ref(false)
    const isError = ref(false)
    const isEmpty = ref(false)

    onMounted(async () => {
      if (!props.tenpufiles || props.tenpufiles?.length < 1) {
        isEmpty.value = true
      }

      isInit.value = true
    })

    return {
      fileDownload,
      fileOpenNewTab,
      thumbBaseUrl,
      isInit,
      isError,
      isEmpty
    };
  },
});
</script>

<style lang="scss" scoped>
</style>
